import { cn } from '@/lib/utils';
import type { PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
    up?: boolean | null;
    className?: string;
}

export const DeltaText: React.FC<Props> = ({ up, children, className = '' }) => {
    return (
        <span
            className={cn(
                up === true && 'text-emerald-500',
                up === false && 'text-red-500',
                up === undefined || (up === null && 'text-neutral-500'),
                'flex items-center',
                className,
            )}
        >
            {children}
        </span>
    );
};
